const EMPTY_RESULT_FAVOURITE_SECTION = 'Nothing here yet! Explore and mark your favorites for quick access';
const NO_ENTRIES_AVAILABLE = 'No Entries Available';

export const getFavouriteSectionEmptyResultsBanner = () => EMPTY_RESULT_FAVOURITE_SECTION;

export const getNoEntriesAvailableBanner = () => NO_ENTRIES_AVAILABLE;




// WEBPACK FOOTER //
// ./src/components/utils/constants.js